import { SchedulerActiveTermQuery } from '../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import { GetTermSectionsCommand } from '../../views/term_courses/commands/get_term_sections_command';
import { ITermCoursesDatasource } from '../../views/term_courses/datasources/term_courses_datasource';
import { ITermPlannedCoursesDatasource } from '../../views/term_courses/datasources/term_planned_courses_datasource';
import { ILogService, ITermCourse } from '../../interfaces/scheduler_interfaces';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { SearchAndCourseFeatureFacade } from '../facades/search_and_courses_feature_facade';
import { SchedulerStudentPlanQuery } from '../queries/scheduler_student_plan_query';
import * as _4 from 'lodash4';
import { GetTermCoursesCommand } from '../../views/term_courses/commands/get_term_courses_command';

export type RemovePlannedCourseSchedulerCommand = (courseId: ITermCourse['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'removePlannedCourseSchedulerCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      log: ILogService,
      ngSchedulerStudentPlanQuery: SchedulerStudentPlanQuery,
      ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      getTermSectionsCommand: GetTermSectionsCommand,
      getTermCoursesCommand: GetTermCoursesCommand,
      ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
      ngTermPlannedCoursesDatasource: ITermPlannedCoursesDatasource
    ) =>
      defineCommandORM('removePlannedCourseSchedulerCommand', (deferred, courseId: ITermCourse['id']) => {
        if (!ngSearchAndCourseFeatureFacade.isFeatureEnabled) {
          log.info('Sorry, remove planned course available only in standalone scheduler!');
          return deferred.resolve();
        }
        const planId = _4.get<number | undefined>(ngSchedulerStudentPlanQuery, 'result.id', undefined);
        if (!planId) {
          log.issue('Sorry, no plan id available to remove the course from');
          return deferred.reject();
        }

        const termId = _4.get<number | undefined>(ngSchedulerActiveTermQuery, 'result.id', undefined);
        if (!termId) {
          log.issue('Sorry, no term id available to remove the course from');
          return deferred.reject();
        }

        const plannedCourse = _4.find(
          ngTermPlannedCoursesDatasource.read(),
          (_plannedCourse) => _plannedCourse.course === courseId
        );
        if (!plannedCourse) {
          log.issue('Sorry, no plan course available to remove');
          return deferred.reject();
        }

        return $http
          .delete(`ap3/studentplans/${planId}/studentplanitems-infer-term/${plannedCourse.id}`)
          .then(() => getTermSectionsCommand(termId))
          .then(() => getTermCoursesCommand(termId))
          .finally(() => deferred.resolve())
          .catch((e) => {
            log.issue('Unable to fetch student plan details');
            deferred.reject(e);
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/commands/remove_planned_course_scheduler_command.ts